/* @flow */

import { DateTime } from 'luxon';
import {
  isGroupTopic,
  getGroupTopic,
  getGroupTopicStartTime,
  getGroupTopicEndTime,
} from '@braindate/domain/lib/topic/util';

import type { Topic } from '@braindate/domain/lib/topic/type';
import { isDateInInterval } from 'src/shared/app/base/date/util/dateUtils';

/**
 * Check if the topic is past
 * @param  {Topic} topic - Topic to check
 * @return {boolean} True if the topic is in the past
 */
export function isTopicPast(topic: Topic): boolean {
  if (!isGroupTopic(topic) || !('date' in topic)) return false;

  const time = getGroupTopicEndTime(getGroupTopic(topic));
  const dateTime = DateTime.fromISO(time);

  return DateTime.local().ts > dateTime.ts;
}

/**
 * Check if the topic is live
 * @param  {Topic} topic - Topic to check
 * @return {boolean} True if the topic is live
 */
export function isTopicLive(topic: Topic): boolean {
  if (!isGroupTopic(topic) || !('date' in topic)) return false;
  const now = DateTime.now();

  const start: string = getGroupTopicStartTime(getGroupTopic(topic));
  const end: string = getGroupTopicEndTime(getGroupTopic(topic));

  return isDateInInterval(now, { start_time: start, end_time: end });
}
